import styled from 'styled-components';

export const Header = styled.header`
  background: #ffffff;
  height: 60px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #d1d1d1;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 7px 20px;
  height: 100%;

  @media (max-width: 768px) {
    padding: 7px 12px;
    gap: 8px;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  padding: 7px 0;

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const TitleAndTabs = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
`;

export const Title = styled.h1`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #242424;
  padding: 10px 0 18px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const TabList = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0 8px 0 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

interface TabProps {
  $isActive?: boolean;
}

export const Tab = styled.button<TabProps>`
  display: flex;
  gap: 6px;
  align-items: flex-start;
  padding: 14px 10px 12px;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: ${props => (props.$isActive ? '#242424' : 'gray')};
  cursor: ${props => (props.$isActive ? 'pointer' : 'not-allowed')};
  font-weight: ${props => (props.$isActive ? 600 : 400)};
  transition: background-color 0.2s ease;

  &:hover {
    background: #f4f4f4;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 12px;
    right: 12px;
    height: 3px;
    background: ${props => (props.$isActive ? '#5b5fc7' : 'transparent')};
    border-radius: 999px 999px 0 0;
  }
`;

export const MoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 6px;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: auto;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f4f4f4;
  }
`;

export const MoreIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #424242;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
